import React, { useRef, useState } from "react"
import EventQuestionAnswerFilterForm from "./component/EventQuestionAnswerList/EventQuestionAnswerListFilterForm";
import EventQuestionAnswerListTable from "./component/EventQuestionAnswerList/EventQuestionAnswerListTable";
import Buttons from "../../components/ui/button/Buttons";
const initState = {
    pageNo: 1,
    pageSize: 20,
    endPage: 100,
    SearchText: "",
    totalCount: 0
}

const EventQuestionAnswerList = (props) => {
    const eventQuestionAnswerListRef = useRef(null)
    const [paginationRequest, setPaginationRequest] = useState(initState);
    const [isModelOpen, setIsModalOpen] = useState(false);

    const handleSearch = () => {
        if (!eventQuestionAnswerListRef.current) {
            return;
        }
        const eventQuestionAnswerData = eventQuestionAnswerListRef.current.getFormData();
        const updatedPaginationRequest = {
            pageNo: 1,
            pageSize: 20,
            endPage: 100,
            SearchText: eventQuestionAnswerData.eventName,
        };
        setPaginationRequest(updatedPaginationRequest);
    };
    const openCloseModal = () => {
        setIsModalOpen(!isModelOpen);
    };

    return (
        <div className="common-first-section">
            <div className="row align-items-end">
                <div className="col-10">
                    <div className="row gx-5">
                        <EventQuestionAnswerFilterForm ref={eventQuestionAnswerListRef} />
                    </div>
                </div>
                <div className="col-2 d-flex justify-content-end align-items-center">
                    <div className="two-button-fixes">
                        <div className="">
                            <Buttons
                                buttonText="Search"
                                buttonTypeClassName="success-btn"
                                onClick={handleSearch}
                            />
                        </div>
                    </div>
                </div>
                <div className="col-lg-12">
                    <div className="common-view-Individual-table">
                        <div className="table-responsive">
                            <EventQuestionAnswerListTable paginationReq={paginationRequest} />
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default EventQuestionAnswerList;
